import AppText from './app_text';
const Label = AppText.withComponent('label');
export default Label;
//# sourceMappingURL=label.js.map